module.exports = __webpack_public_path__ + "assets/PTS55F-webfont.40aa43655bdf1e7fa0d56dc62724c89797b882e7509ba7062f78e1345a6e7c28.woff";